<template>
  <section>
    <gs-header
      title="Sửa user"
      :breadcrumbs="[
        {title: 'Quản lý user', route: {name: 'user'}}
      ]">
    </gs-header>
    <div class="padding-lg-all">
      <el-form :model="localUser" :rules="rules" ref="editUserForm" label-width="200px" label-position="top" @submit.prevent.native="validateBeforeSubmitUser('editUserForm')">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Tên cửa hàng" prop="shop_name">
              <el-input v-model="localUser.shop_name" placeholder="Tên cửa hàng"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Họ tên" prop="name">
              <el-input v-model="localUser.name" placeholder="Họ tên"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Số điện thoại" prop="phone">
              <el-input v-model="localUser.phone" placeholder="Số điện thoại"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Email" prop="email">
              <el-input v-model="localUser.email" placeholder="Email"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="Mật khẩu" prop="password">
              <el-input type="password" v-model="localUser.password" placeholder="Mật khẩu"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Nhập lại mật khẩu" prop="retype_password">
              <el-input type="password" v-model="localUser.retype_password" placeholder="Nhập lại mật khẩu"></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-form-item>
          <button :disabled="submitting" class="ui blue basic small button" native-type="submit">Lưu lại</button>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
import { editUser, getUser } from 'src/api/users'
import { head } from 'lodash'
import mixins from './mixins'
export default {

  name: 'EditUser',
  mixins: [mixins],
  methods: {
    validateBeforeSubmitUser () {
      this.submitting = true
      this.$refs.editUserForm.validate(valid => {
        if (valid) {
          this.changedData = false
          editUser(this.$route.params.id, this.localUser).then(response => {
            switch (response.code) {
              case 200:
                this.$store.dispatch('showNotify', {
                  title: 'Sửa thành công',
                  body: 'Sửa user  thành công'
                })
                this.reloadGsTableAfterRedirect({name: 'user'}, 'clients')
                this.toggleLoadding(false)
                this.submitting = false
                break
              case 422:
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                })
                this.toggleLoadding(false)
                this.submitting = false
                break
              default:
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: 'Sửa user thất bại vui lòng kiểm tra lại thông tin',
                  type: 'warning'
                })
                this.toggleLoadding(false)
                this.submitting = false
            }
          })
        } else {
          this.$store.dispatch('toggleLoadding', false, {root: true})
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          })
          return false
        }
      })
    }
  },
  mounted () {
    getUser(this.$route.params.id, {}).then(response => {
      if (response.code === 200) {
        this.localUser.id = response.data.id
        this.localUser.shop_name = response.data.shop_name
        this.localUser.name = response.data.name
        this.localUser.phone = response.data.phone
        this.localUser.email = response.data.email
        setTimeout(() => {
          this.watching = true
        }, 100)
      } else {
        this.$router.push({name: 'carrier'})
        this.$store.dispatch('showNotify', {
          title: 'Vui lòng kiểm tra thông tin cần nhập',
          body: 'Không tìm thấy tài nguyên',
          type: 'warning'
        })
      }
    })
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// EditUser.vue?464ce862